/* Botón flotante de WhatsApp — Dermavela
   Cierra la etiqueta breve al pulsar la X.
   Deliberadamente SIN sessionStorage/localStorage: la etiqueta debe
   reaparecer siempre en cada recarga de página, sin excepción. */

(function () {
  var ROOT_SELECTOR = '[data-dv-wa]';

  function init(root) {
    var closeButton = root.querySelector('[data-dv-wa-close]');

    if (!closeButton) return;

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      root.classList.add('is-label-closed');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  });
})();
